<template>
  <section class="support-section">

    <div class="container">

      <div class="header">

        <h1>
          Ensemble, faisons grandir l'entraide
        </h1>

        <p>
          Chaque contribution permet à HayMiutyun de développer des projets
          solidaires, d'aider davantage de personnes et de renforcer les liens
          au sein de la communauté arménienne.
        </p>

      </div>


      <div class="hero-card">

        <div class="hero-icon">
          +
        </div>

        <div>

          <h2>
            Pourquoi soutenir HayMiutyun ?
          </h2>

          <p>
            HayMiutyun est construit autour d'une idée simple :
            créer une communauté où chacun peut aider et être aidé.
          </p>

          <p>
            Vos dons nous permettent de mettre en place des initiatives
            concrètes et de développer des outils pour faciliter l'entraide
            entre les membres de notre communauté.
          </p>

        </div>

      </div>


      <h2 class="title">
        Où ira votre soutien ?
      </h2>


      <div class="projects">


     <div class="project-card">

  <div class="icon">
    <HandHeart />
  </div>

  <h3>
    Projets caritatifs
  </h3>

  <p>
    Financer des actions solidaires pour accompagner les personnes
    qui rencontrent des difficultés et répondre aux besoins de notre
    communauté.
  </p>

</div>



<div class="project-card">

  <div class="icon">
    <CalendarHeart />
  </div>

  <h3>
    Événements communautaires
  </h3>

  <p>
    Organiser des rencontres, événements culturels et moments de
    partage pour rapprocher les membres de la communauté arménienne.
  </p>

</div>



<div class="project-card">

  <div class="icon">
    <Rocket />
  </div>

  <h3>
    Développement de HayMiutyun
  </h3>

  <p>
    Améliorer la plateforme, créer de nouveaux services et permettre
    à davantage de personnes de bénéficier de notre réseau d'entraide.
  </p>

</div>



<div class="project-card">

  <div class="icon">
    <Handshake />
  </div>

  <h3>
    Soutien aux initiatives locales
  </h3>

  <p>
    Collaborer avec des associations et soutenir des projets ayant
    un impact positif pour notre communauté.
  </p>

</div>


      </div>



      <div class="transparency">

        <div class="shield">
          ✓
        </div>

        <div>

          <h2>
            Une utilisation transparente
          </h2>

          <p>
            Nous souhaitons construire une relation de confiance avec notre
            communauté. Chaque contribution sera utilisée avec responsabilité
            afin de financer des projets utiles et ayant un réel impact.
          </p>

        </div>

      </div>



      <div class="donation-card">

        <h2>
          Vous souhaitez nous soutenir ?
        </h2>

        <p>
          Chaque geste compte. Ensemble, nous pouvons construire une communauté
          plus forte, plus solidaire et plus connectée.
        </p>

        <button>
          Faire un don
        </button>

      </div>


    </div>

  </section>
</template>

<script setup>
import {
  HandHeart,
  CalendarHeart,
  Rocket,
  Handshake
} from "lucide-vue-next"
</script>

<style scoped>

*{
  box-sizing:border-box
}

.support-section{
  padding:40px 20px;
  background:linear-gradient(180deg,#fff,#f7f8fc)
}

.container{
  max-width:1200px;
  width:100%;
  margin:auto
}

.header{
  text-align:center;
  margin-bottom:50px
}

.header h1{
  font-size:48px;
  font-weight:800;
  margin:0 0 15px;
  background:linear-gradient(90deg,#D90012,#0033A0,#F2A800);
  -webkit-background-clip:text;
  color:transparent
}

.header p{
  max-width:800px;
  margin:auto;
  font-size:18px;
  color:#666;
  line-height:1.8
}


.hero-card{
  display:flex;
  align-items:center;
  gap:35px;
  background:#fff;
  padding:35px;
  border-radius:30px;
  box-shadow:0 20px 50px rgba(0,0,0,.08);
  border-left:5px solid #D90012;
  margin-bottom:60px
}


.hero-icon{
  width:75px;
  height:75px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:25px;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  color:white;
  font-size:35px;
  font-weight:bold;
  flex-shrink:0
}


.hero-card h2{
  font-size:32px;
  margin:0 0 15px
}

.hero-card p{
  color:#666;
  line-height:1.8
}


.title{
  text-align:center;
  font-size:32px;
  margin-bottom:35px
}


.projects{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:20px;
  margin-bottom:60px
}


.project-card{
  background:white;
  padding:30px;
  border-radius:25px;
  text-align:center;
  box-shadow:0 10px 30px rgba(0,0,0,.07);
  transition:.3s;
  border-top:4px solid transparent
}


.project-card:nth-child(1){
  border-color:#D90012
}

.project-card:nth-child(2){
  border-color:#0033A0
}

.project-card:nth-child(3){
  border-color:#F2A800
}

.project-card:nth-child(4){
  border-color:#D90012
}


.project-card:hover{
  transform:translateY(-8px)
}


.icon{
  width:60px;
  height:60px;
  margin:0 auto 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
  background:#fff1f2;
  color:#D90012;
  font-size:28px;
  font-weight:bold
}


.project-card h3{
  font-size:21px
}


.project-card p{
  color:#666;
  line-height:1.7
}


.transparency{
  display:flex;
  align-items:center;
  gap:30px;
  background:white;
  padding:35px;
  border-radius:30px;
  border-left:6px solid #0033A0;
  margin-bottom:60px;
  box-shadow:0 15px 40px rgba(0,0,0,.08)
}


.shield{
  width:65px;
  height:65px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
  background:#eaf0ff;
  color:#0033A0;
  font-size:30px;
  font-weight:bold
}


.transparency h2{
  font-size:30px
}


.transparency p{
  color:#666;
  line-height:1.8
}


.donation-card{
  padding:45px;
  text-align:center;
  border-radius:35px;
  color:white;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  box-shadow:0 20px 50px rgba(0,0,0,.15)
}


.donation-card h2{
  font-size:36px;
  margin:0 0 10px
}


.donation-card p{
  max-width:700px;
  margin:0 auto 25px;
  font-size:18px;
  line-height:1.8
}


button{
  border:none;
  background:white;
  color:#D90012;
  padding:15px 35px;
  border-radius:30px;
  font-size:18px;
  font-weight:700;
  cursor:pointer;
  transition:.3s
}


button:hover{
  transform:translateY(-3px);
  box-shadow:0 10px 25px rgba(0,0,0,.15)
}


@media(max-width:1000px){

  .projects{
    grid-template-columns:repeat(2,1fr)
  }

}


@media(max-width:700px){

  .header h1{
    font-size:36px
  }

  .projects{
    grid-template-columns:1fr
  }

  .hero-card,
  .transparency{
    flex-direction:column;
    text-align:center
  }

  .donation-card{
    padding:35px 20px
  }

}

</style>